'use client';

import React from 'react';
import { EVENTS } from '@/constants/tracking';
import { TolstoyService } from '@/features/integrations';
import { TolstoyIntegration } from './TolstoyIntegration';

const INTEGRATION_STEPS = [
  'Download Tolstoy to your store and create your account.',
  'Your Bunu videos will automatically appear in the library tab.',
  'Choose a layout and populate videos.',
  'Publish to the site for free, with 0 code needed.',
];

const WEBSITE_SUMMARY =
  'Tolstoy integration allows you to showcase your videos in an interactive and Shoppable experience.';

const EXAMPLES = [
  {
    src: '/assets/product-page-stories-example-1.jpg',
    alt: 'Customer testimonial video',
  },
  {
    src: '/assets/product-page-stories-example-2.jpg',
    alt: 'Product showcase video',
  },
];

const PublishWebsite: React.FC = () => {
  return (
    <TolstoyIntegration
      title="Publish your Bunu videos using Tolstoy, for free."
      summary={WEBSITE_SUMMARY}
      integrationSteps={INTEGRATION_STEPS}
      examples={EXAMPLES}
      publishEvent={EVENTS.PUBLISH_ON_WEBSITE_WITH_TOLSTOY}
      getTolstoyEvent={EVENTS.GET_TOLSTOY_TO_PUBLISH_ON_WEBSITE}
      redirectRoute={TolstoyService.Routes.OnsiteCreate}
    />
  );
};

export default PublishWebsite;
